/**
 * CihClosingCta — dark full-bleed closing band. Text-left, button-right on
 * desktop; stacks centered on mobile. Replaces CtaBanner on CIH pages.
 *
 * Aliases: closing cta, cta band, bottom cta
 */

import type { ReactNode } from "react";

type Props = {
  readonly kicker?: string;
  readonly headline: string;
  readonly sub?: string;
  readonly cta: ReactNode;
  readonly extra?: ReactNode;
};

export function CihClosingCta({
  kicker = "Ready when you are",
  headline,
  sub,
  cta,
  extra,
}: Props) {
  return (
    <section className="relative overflow-hidden border-t border-gray-900 bg-gray-950">
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute -top-32 right-[-8%] h-96 w-96 rounded-full bg-purple-700/25 blur-3xl" />
        <div className="absolute -bottom-40 left-[-6%] h-80 w-80 rounded-full bg-violet-800/20 blur-3xl" />
      </div>
      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-20 md:grid-cols-[1fr_auto] md:items-center md:gap-14 md:py-24 xl:px-0">
        <div>
          <div className="text-xs font-medium tracking-[0.22em] text-purple-300 uppercase">
            ● {kicker}
          </div>
          <h2 className="mt-3 font-heading text-4xl leading-tight font-medium tracking-tight text-white md:text-5xl">
            {headline}
          </h2>
          {sub ? <p className="mt-3 text-sm text-gray-400">{sub}</p> : null}
          {extra ? <div className="mt-4">{extra}</div> : null}
        </div>
        <div className="md:justify-self-end">{cta}</div>
      </div>
    </section>
  );
}
